import Vue from 'vue'
import { RUN_USER_LOGIN,RUN_USER_LOGOUT,RUN_STATE_LOAD,GET_TOKEN,SET_STATE,SET_STATE_PERSIST_LOCAL,SET_TOGGLE_LOADER,SET_INFO,GET_USER, SAVE_FIREBASE_TOKEN,RUN_USER_LOGIN_2FA,RUN_GENERATE_2FA_QRCODE,RUN_VERIFY_2FA_QRCODE,RUN_DISABLE_2FA_QRCODE} from '../types'
import * as types from '@/types'
import * as RxFactory from './api/rx-factory'
import * as Enpoints from './api/endpoints'
import { Const } from '../plugins/fxView/provider/candle-history/lib/const.cls'
import * as COMMON from './commonFunctions'

export const actions = {
  	[RUN_USER_LOGIN]({commit, state, dispatch,getters}, credentials){
		_executeApi(Enpoints.EP_ADMIN_LOGIN, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				if(parseInt(result.res_data.user.profile.gAuthenticatorEnabled) == 1){
					credentials.localParams.parameter.gAuthenticatorEnabled = true
				}else{
					result.res_data.user.loggedIn = true
					let role_array = (result.res_data.user.roles || '').split('&')
					result.res_data.user.roles = role_array
					
					commit(SET_STATE, result.res_data.user)
					localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))
					
					let permision_array = (result.res_data.user.permissions || '').split(',')
					commit(Const.SET_PERMISSION_LIST, permision_array)
					
					credentials.localParams.parameter.$router.push('/dashboard'); 
					credentials.localParams.parameter.$notify({
						group: 'foo',
						type : 'success',
						text: 'login successfully',
						duration: 10000,
						closeOnClick : true
					});
				}
			}else{
				credentials.localParams.parameter.message = result.res_data
				credentials.localParams.parameter.message_type = 'error'
			}
		})
  	},

  [RUN_USER_LOGIN_2FA]({commit, state, dispatch,getters}, credentials){
  	_executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
		 //COMMON._executeApi(Enpoints.EP_USER_LOGIN_2FA, credentials,'',commit, (error, result)=>{
			if(!error){
				localStorage.setItem('unauthFlag', '')
				result.res_data.user.loggedIn = true
				commit(SET_STATE, result.res_data.user)
				localStorage.setItem('user', btoa(JSON.stringify(result.res_data.user)))				
				let getpath = localStorage.getItem("lastPath")
				let getQuery = localStorage.getItem("query")

				//console.log(localStorage.getItem("lastPath"),getpath)
				if(getpath != undefined){
					if(getQuery && getQuery != undefined){
						credentials.localParams.parameter.$router.replace({path:getpath,query:{'ticketData' :getQuery}})
					}else{
						credentials.localParams.parameter.$router.push(getpath)
					}
				}else{
					// if(parseInt(result.res_data.user.step) < 3){
					// 	let lastStep = '/step'+(parseInt(result.res_data.user.step) + 1)
					// 	credentials.localParams.parameter.$router.replace(lastStep)
					// }else{
						credentials.localParams.parameter.$router.push('/dashboard')
					//}
				}
			}else{
				// COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_msg,'error')
			}
		})
  },

  //==============================2FA===========================================
	[RUN_GENERATE_2FA_QRCODE]({commit, state, getters}, credentials) {
			_executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
		 //COMMON._executeApi(Enpoints.EP_GENERATE_2FA_QRCODE, credentials,'',commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.src_data = result.res_data
			}else{
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = true
				}
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
	[RUN_VERIFY_2FA_QRCODE]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
		 //COMMON._executeApi(Enpoints.EP_VERIFY_2FA_QRCODE, credentials,'',commit, (error, result)=>{
			if(!error){
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 1
				commit(SET_STATE, user_json)
				localStorage.setItem('unauthFlag', '')
				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 1						
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				credentials.localParams.parameter.div_show = ''
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = false
					
				}else{
					credentials.localParams.parameter.otp = ''
					credentials.localParams.parameter.div_show = ''
				}
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz1','success')
			}else{
				//credentials.localParams.parameter.div_show = ''
				if(credentials.localParams.parameter.call_from != '' || credentials.localParams.parameter.call_from != null){
					credentials.localParams.parameter.$parent.authComponent = true
				}
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
				
			}
		})
	},
	[RUN_DISABLE_2FA_QRCODE]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
		//COMMON._executeApi(Enpoints.EP_DISABLE_2FA_QRCODE, credentials,'',commit, (error, result)=>{
			if(!error){
				credentials.localParams.parameter.DisableOtp = ''
				credentials.localParams.parameter.div_show = ''
				credentials.localParams.parameter.generateQrCode()
				let user_json = getters['GET_USER']
				user_json.profile.gAuthenticatorEnabled = 0
				commit(SET_STATE, user_json)


				var user = localStorage.getItem('user')
				user = atob(user)	;	user = JSON.parse(user)
				user.profile.gAuthenticatorEnabled = 0						
				localStorage.setItem('user', btoa(JSON.stringify(user)))
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,'suceessMsz2','success')
			}else{
				 COMMON._messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},

	[RUN_USER_LOGOUT]({commit, state, getters}, getdata) {
		RxFactory.get(Enpoints.BASE_URL + Enpoints.EP_ADMIN_LOGOUT, {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
		.map(response => response.data)
		.subscribe(data => {
				_handleLogout(data, commit, {router: getdata.router,parameter: getdata.parameter, forward:true})
			},
			(e, d, s) => {
				_handleLogout(e, commit, {router: getdata.router, forward:true})
			}
		)
	},
	[RUN_STATE_LOAD] ({commit, dispatch, state, getters}) {
		const data = {}
		let user = localStorage.getItem('user')
		if (user) {
			user = atob(user) 
			user = JSON.parse(user)
		}
		commit(SET_STATE, user)
		if(user !== null && user !==''){
			RxFactory.post(Enpoints.BASE_URL + "/get/fresh/user/data", {}  , {'Authorization': 'Bearer ' + getters[GET_TOKEN]})
				.map(response => response.data)
				.subscribe(data => {
					if ('info' in data) {
						if (data.info === 'OK') {
							data.data.user.loggedIn = true
							let role_array = (data.data.user.roles || '').split('&')
							data.data.user.roles = role_array
				
							commit(SET_STATE, data.data.user)
							localStorage.setItem('user', btoa(JSON.stringify(data.data.user)))
							
							let permision_array = (data.data.user.permissions || '').split(',')
							commit(Const.SET_PERMISSION_LIST, permision_array)
						}
					}
				},
				e => {					
					_handleErrorResponse(e, commit)
				}
			)
		}
	},
	[SAVE_FIREBASE_TOKEN]({commit, state, getters}, credentials) {
		_executeApi(Enpoints.EP_SAVE_FIREBASE_TOKEN, credentials.globalParams , credentials.localParams,commit, (error, result)=>{
			if(!error){
				console.log('firebase_token--',result.res_data)
			}else{
				_messageDisplayFunction(credentials.localParams.parameter,result.res_data,'error')
			}
		})
	},
}

//------------------------------------------------functions----------------------------------------------------------------------
function _cleanUp (commit, msg, status, loaderId) {
  let loaderArr = (typeof loaderId !== 'undefined') ? [loaderId] : []
  commit(SET_TOGGLE_LOADER, loaderArr)
  commit(SET_INFO, msg)
}

function _handleErrorResponse (e, commit) {
    let response = {info: 'NOK', msg: 'Service not available'}
	if (typeof e.response === 'undefined') {
		try {
			const statusCheck = e.toString().toLowerCase()
			if (statusCheck.indexOf('network') > -1) {
			response = {info: 'NOK', msg: 'Network Error'}
			}
		} catch(e){}
	}else{
		if(e.response.status == '401'){
			window.location.href = "/";
		}
		response = e.response.data
	}
	_cleanUp(commit, response, response.status)
}

function _handleLogout (data, commit,options,getters) {
	const router = options.router
	let user = {
		active: 0,
		country: '',
		created: '',
		email: '',
		profile: {
			firstname: '',
			lastname: '',
			pid: '',
			cid: ''
		},
		roles: '',
		token: false,
		username: '',
		loggedIn: false
	}
	
	commit(SET_STATE, user)
	commit(SET_STATE_PERSIST_LOCAL)
	localStorage.clear()
	if ( 'msg' in data && 'info' in data) {
		_cleanUp(commit, data.msg, data.info)
	}
	if (options.forward === true) {
		options.parameter.$notify({
			group: 'foo',
			type : 'success',
			text: 'logout successfully',
			duration: 10000,
			closeOnClick : true
		});
		router.replace('/')
	}
}

function _executeApi (apiLink, globalParams, localParams,commit, callback) {
	try{
		let response_array = []
		localParams.parameter.pageLoader = true
		RxFactory.post(Enpoints.BASE_URL + apiLink, globalParams)
		.map(response => response.data)
		.subscribe(data => 
		{	localParams.parameter.pageLoader = false
			if ('info' in data){
				if (data.info === 'OK') {
					response_array.res_data = data.data
					callback(false, response_array)
				}
				else{
					response_array.res_data = data.msg
					callback(true, response_array)
				}
			}
		},
		e => {	_handleErrorResponse(e, commit)	}) 
	}catch(ex){	_handleErrorResponse(ex, commit) }
}




// WEBPACK FOOTER //
// ./src/store/actions.js